import { db, getMeta } from './db';
import { printBill } from './print';
import { useSession } from './session';
import { toast } from './toast';

export async function reprintLast() {
  const id = await getMeta<string | null>('lastBillId', null);
  const bill = id ? await db.bills.get(id) : undefined;
  const me = useSession.getState().me;
  if (!bill || !me) return toast.info('No bill to reprint yet.');
  await printBill(bill, me);
}
